import React, { useCallback, useEffect, useState } from 'react';
import MenuPage from './MenuPage';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Footer from './Footer';
import { Button } from 'primereact/button';

const serverUrl = 'https://ihongss.com';

const LecturePage = () => {
    const { token } = useSelector((state) => state.AuthReducer);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [currentVideoUrl, setCurrentVideoUrl] = useState('');
    const [activePid, setActivePid] = useState(null);
    const [activePostid, setActivePostid] = useState(null);
    const [docs, setDocs] = useState([]);

    // 2. 목록 항목 클릭 시 실행할 핸들러 (먼저 선언해야 handleData에서 사용 가능)
    const handleContent = useCallback((nodeId, videoUrl, postId) => {
        setActivePid(nodeId);
        sessionStorage.setItem("PID1", nodeId);
        setCurrentVideoUrl(videoUrl);
        setActivePostid(postId);
    }, []);

    const handleData = useCallback(async () => {
        var pid = sessionStorage.getItem("PID1");
        const url = `${serverUrl}/api/lecture/lecture_video_list.json`;
        const headers = { "Content-Type": "application/json", "auth": token };
        const { data } = await axios.get(url, { headers });

        if (data.status === 200) {
            if (data.result.length > 0) {
                setDocs(data.result);

                if (pid === null) {
                    pid = data.result[0]._id;
                }
                const currentItem = data.result.find(item => item._id === pid) || data.result[0];
                handleContent(currentItem._id, currentItem.url, currentItem.pid);
            }
        }
        else if (data.status < 0) {
            dispatch({ type: 'logout' });
            navigate(`/`);
        }
    }, [token, navigate, dispatch, handleContent]);

    useEffect(() => {
        handleData();
    }, [token, handleData]);

    return (
        <div>
            <div className="card flex justify-content-center"
                style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1000,
                    background: '#f0f2f5',
                    paddingTop: '5px',
                    paddingBottom: '2px',
                }}
            >
                <div>
                    <MenuPage />
                </div>
                <hr />
            </div>

            <div style={{ width: '100%', padding: '0 0px', boxSizing: 'border-box' }}>
                <div style={{ display: 'flex', width: '100%', alignItems: 'flex-start' }}>

                    <div style={{ width: '80%', paddingRight: '20px' }}>
                        <div id="content_data" style={{ backgroundColor: '#ffffff', padding: '10px', minHeight: '500px' }}>
                            {currentVideoUrl ? (
                                <>
                                    <a
                                        href={`/post?postId=${activePostid}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="no-underline"
                                    >
                                        <Button
                                            label="강의자료보기"
                                            size="small"
                                            severity="info"
                                            outlined
                                            icon="pi pi-external-link"
                                            iconPos="right"
                                            className="px-3 py-2 font-medium border-round-md hover:surface-100 transition-duration-150"
                                        />
                                    </a>

                                    <div style={{ width: '100%', textAlign: 'center' }}>
                                        <video
                                            key={currentVideoUrl}
                                            width="100%"
                                            height="auto"
                                            style={{ maxHeight: '600px', backgroundColor: '#000' }}
                                            controls
                                            controlsList="nodownload"
                                            autoPlay={false}
                                            muted={true}
                                        >
                                            <source src={currentVideoUrl} type="video/mp4" />
                                            사용 중인 브라우저가 동영상 재생을 지원하지 않습니다.
                                        </video>
                                    </div>
                                </>
                            ) : (
                                <p>강의 영상이 없습니다.</p>
                            )}
                        </div>
                    </div>

                    <div style={{
                        width: '20%',
                        paddingLeft: '20px',
                        borderLeft: '1px solid #e0e0e0',
                        position: 'sticky',
                        top: '78px',
                        maxHeight: 'calc(100vh - 110px)',
                        overflowY: 'auto'
                    }}>
                        <div style={{ background: '#ffffff', padding: '10px 5px' }}>
                            {
                                docs?.length > 0 && docs.map((item, index) => (
                                    <p key={item._id} style={{
                                        margin: '0',
                                        padding: '8px 10px',
                                        borderRadius: '4px',
                                        backgroundColor: activePid === item._id ? '#e8f5e9' : 'transparent'
                                    }}>
                                        <a
                                            href="#!_"
                                            style={{
                                                textDecoration: 'none',
                                                color: activePid === item._id ? '#2e7d32' : '#333333',
                                                fontWeight: activePid === item._id ? 'bold' : 'normal',
                                                display: 'block'
                                            }}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleContent(item._id, item.url);
                                            }}
                                        >
                                            {index + 1}. {item.title ?? '제목 없음'}
                                        </a>
                                    </p>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default LecturePage;